import { memo, useSyncExternalStore } from 'react';

import VideoOverlayFilesInput from '@/Pages/Clip/ClipPlayer/ClipAssets/VideoOverlay/VideoOverlayFilesInput';
import VideoOverlayLibraryModal from '@/Pages/Clip/ClipPlayer/ClipAssets/VideoOverlay/VideoOverlayLibraryModal';
import { useVideoOverlay } from '@/Pages/Clip/ClipPlayer/ClipAssets/VideoOverlay/useVideoOverlay';
import { VideoOverlayTrack } from '@/Pages/Clip/ClipPlayer/ClipAssets/VideoOverlay/types';
import { FeatureFlagKeys } from '@/services/featureFlag';
import featureFlagStore from '@/stores/featureFlagStore';

const ClipCustomizerVideoPopup = ({ closePopup }: { closePopup: () => void }) => {
  const featureFlags = useSyncExternalStore(featureFlagStore.subscribe, featureFlagStore.getSnapshot);
  const isUseCLReplaceVideoOverlaysEnabled = featureFlags[FeatureFlagKeys.Use_CL_Replace_Video_Overlays];

  const { uploadVideo, selectLibraryVideo } = useVideoOverlay({ onUploadComplete: closePopup });

  const handleModalConfirm = async (
    selection:
      | { type: 'library'; video: VideoOverlayTrack }
      | { type: 'upload'; file: File }
      | { type: 'recently-used'; video: VideoOverlayTrack }
  ): Promise<string | undefined> => {
    if (selection.type === 'library' || selection.type === 'recently-used') {
      await selectLibraryVideo(selection.video);
      closePopup();
      return undefined;
    }

    const uploadedUrl = await uploadVideo([selection.file]);
    closePopup();
    return uploadedUrl;
  };

  if (isUseCLReplaceVideoOverlaysEnabled) {
    return <VideoOverlayLibraryModal onClose={closePopup} onConfirm={handleModalConfirm} />;
  }

  return (
    <div className="flex max-h-[54vh] w-[23rem] flex-col overflow-y-auto rounded-lg border bg-white shadow">
      <div className="sticky top-0 z-10 mb-4 flex items-center justify-between bg-white px-4 pt-3">
        <div className="text-lg font-medium">Videos</div>
      </div>
      <div className="mb-4 px-4">
        <VideoOverlayFilesInput onUploadComplete={closePopup} />
      </div>
    </div>
  );
};

export default memo(ClipCustomizerVideoPopup);
